import axios from "axios";

const COMPANY_SERVICE_BASE = `${process.env.REACT_APP_API_URL}/companyService/api/companies`;

const apiClient = axios.create({
  baseURL: COMPANY_SERVICE_BASE,
  withCredentials: true,
});
// Add Authorization token to each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
const companyApi = {
  createCompany: (companyData) => {
    return apiClient.post("/addCompany", companyData);
  },
  getCompaniesByEmail: (email, page, pageSize, sortedColumn, sortOrder) =>
    apiClient.get(`/getCompanyByAdminEmail`, {
      params: { email, page, pageSize, sortedColumn, sortOrder },
    }),
  getListOfCompanyByAdminEmail: (email) =>
    apiClient.get(`/getListOfCompanyByAdminEmail`, {
      params: { email },
    }),

  deleteCompanyByAdmin: (companyId, userEmail) =>
    apiClient.put(`/deleteCompanyByAdmin/${companyId}`, null, {
      params: { userEmail },
    }),

  companyCount: async () => {
    try {
      const response = await apiClient.get("/companyCount");
      return response.data;
    } catch (error) {
      console.error("Error fetching company count:", error);
      throw error;
    }
  },

  getAllCompanyNames: () => {
    return apiClient.get("/companyNames");
  },

  getLocationsByCompanyName: (companyName) => {
    return apiClient.get(`/locations?companyName=${companyName}`);
  },
};
export default companyApi;
